import React from 'react';
import PropTypes from 'prop-types';
import RavenUtil from 'APP_ROOT/components/common/ravenUtil';
import { strings } from '../../../../localization';

const FALLBACK_IMAGE = '/images/no-image-preview.jpg';

export default class LiveMediaImage extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            errorOccurred: false
        };
    }

    handleImageError = (event) => {
        this.setState({ errorOccurred: true });
    };

    render() {

        if (!this.props.previewImageData || this.state.errorOccurred) {
            return (
                <div className="event-image-preview">
                    <img
                        src={FALLBACK_IMAGE}
                        onError={this.handleImageError}
                        alt={strings.no_preview_available}
                        title={strings.no_preview_available}
                    />
                    <div className="timestamp-label">{dateLocalizedString}</div>
                </div>
            )
        }

        const dateLocalizedString = RavenUtil.toDateString(this.props.date);

        return (
            <div className="event-image-preview">
                <img
                    src={this.props.previewImageData}
                    onError={this.handleImageError}
                    alt={strings.live_media_preview}
                />
                <div className="timestamp-label">{dateLocalizedString}</div>
            </div>
        )
    }
}

LiveMediaImage.propTypes = {
    previewImageData: PropTypes.oneOfType([
        PropTypes.object, // image data src
        PropTypes.string  // or image url src
    ]),
    date: PropTypes.instanceOf(Date).isRequired
};
